import { makeStyles } from '@mui/styles'
const useStyleSearchSubscriber = makeStyles(() => ({
  stepperStyleSeeMore: {
    width: 800,
    '@media all and (max-width: 800px)': {
      width: '600px'
    },
    '@media all and (max-width: 600px)': {
      width: '400px'
    },
    '@media all and (max-width: 400px)': {
      width: '100%'
    }
  },
  title: {
    fontWeight: 'lighter',

    '@media all and (max-width: 600px)': {
      fontSize: '0.9em'
    }
  }
}))

export default useStyleSearchSubscriber
